import React from 'react';
import logo from './images/logo.png';

function Footer({ activePage }) {
  return (
    <footer className="footer">
      <div className="footer-grid">
        <div className="footer-column">
          <div className="footer-logo">
            <img src={logo} className="footer-logo-img" alt="VSHOTS Logo" />
          </div>
          <p className="footer-description">VShots is a content-driven production company focused on crafting visually rich narratives for modern audiences. We work across entertainment and digital ecosystems, delivering projects with creative integrity, technical excellence, and scalable execution.</p>
          <div className="social-icons">
            <a href="https://www.instagram.com/vshots_official?igsh=MXZnNXl2dG05dGpqbw==" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
            <a href="https://www.youtube.com/@Vshots_app/" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>
            <a href="https://www.facebook.com/vshotsapp/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a>
            <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin-in"></i></a>
          </div>
        </div>
        <div className="footer-column">
          <h4>Pages</h4>
          <div className="footer-links">
            <a href="/" className={activePage === 'home' ? 'active' : ''}>Home</a>
            <a href="/what-we-do" className={activePage === 'what-we-do' ? 'active' : ''}>What we do</a>
            <a href="/projects" className={activePage === 'projects' ? 'active' : ''}>Projects</a>
            <a href="/bts-projects" className={activePage === 'bts-project' ? 'active' : ''}>BTS Gallery</a>
            <a href="/founders" className={activePage === 'founders' ? 'active' : ''}>Founders</a>
            <a href="/contact-us" className={activePage === 'contact-us' ? 'active' : ''}>Contact Us</a>
          </div>
        </div>
        <div className="footer-column">
          <div style={{ marginTop: '15px', color: '#aaa', fontSize: '0.9rem', lineHeight: '1.5' }}>
            <p style={{ margin: 0 }}><strong>VShots Pvt Ltd</strong></p>
            <p style={{ margin: 0 }}>B 904, Venus building, Veera Desai Road,</p>
            <p style={{ margin: 0 }}>Near Court Yard Hotel, Andheri West Mumbai 400053</p>
            <p style={{ margin: '5px 0 0 0' }}>GST: 27AALCV2296B1Z6</p>
          </div>
        </div>
      </div>
      <div className="copyright">
        &copy;{new Date().getFullYear()} VShots Private Limited. All Rights Reserved.
      </div>
    </footer>
  );
}

export default Footer;